import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27722 13785"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#292525}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M4115 12398c-1504 0-2728-1224-2728-2728 0-1505 1224-2729 2728-2729 1162 0 2154 732 2547 1758H4338c-517 0-936 419-936 936s419 936 936 936h2349c-373 1062-1384 1827-2572 1827zm10397-4913s-2404 845-6080-346h-93s-106 681-121 1560h-104c-242-996-848-1852-1668-2418l2944 753s4669 1157 5262-554c463-864 662-1283 2087-2278 0 0-3940-1832-6587 613 0 0-1740 1613-5410-594 0 0-4472-216-537 1336-30-1-59-3-90-3C1846 5554 0 7401 0 9670s1846 4115 4115 4115c1959 0 3602-1377 4014-3214h239c120 574 326 1100 665 1457h7789s-2299-1491-2310-4543z"
        className="fil0"
      />
      <path
        d="M23514 12335c-1555 0-2820-1266-2820-2821 0-486 123-944 340-1343l1990 1989c135 136 313 204 490 204 178 0 355-68 491-204 270-270 270-710 0-980l-2028-2029c443-289 971-458 1537-458 1555 0 2821 1265 2821 2821 0 1555-1266 2821-2821 2821zm0-7029c-950 0-1827 317-2533 850l-130-129c575-526 930-1248 930-2045 0-1608-6303-5990-3226-2913 3090 3090-5583 3191-3066 8601 882 2288 5540 5046 3225 1317-2031-3271 0-4095 0-4095 310-14 607-67 888-155l425 425c-454 672-720 1482-720 2352 0 2320 1887 4208 4207 4208s4208-1888 4208-4208c0-2321-1888-4208-4208-4208z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
